exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".select-with-searchbox md-content{margin-top:48px;padding:0;min-height:0}.select-with-searchbox .header-searchbox{border:none;outline:none;height:100%;width:100%;padding:0}.select-with-searchbox .select-header{box-shadow:0 1px 0 0 rgba(0,0,0,.1),0 0 0 0 rgba(0,0,0,.14),0 0 0 0 rgba(0,0,0,.12);padding-left:10.667px;height:48px;cursor:pointer;display:flex;align-items:center;width:100%;position:fixed;top:0;left:0;right:0;background-color:#fff}.select-with-searchbox md-content._md{max-height:240px;padding:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./sources/components/common/select-search/select-search.scss
// module id = 551
// module chunks = 0